import { Api } from '@axiom/ui';
import type {
  Candidate,
  CandidateProfileTopFocusAreas,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

export type CandidateProfileTopFocusAreasBody = Pick<
  CandidateProfileTopFocusAreas,
  'topFocusAreas' | 'hiddenFocusAreas'
>;

class CandidateProfileTopFocusAreasApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readProfileTopFocusAreas(id: Candidate['id']) {
    return super.read<{ data: CandidateProfileTopFocusAreas }>({
      endpoint: `/candidates/${id}/profileTopFocusAreas`,
      method: 'GET',
    });
  }

  async saveProfileTopFocusAreas(
    id: Candidate['id'],
    body: CandidateProfileTopFocusAreasBody
  ) {
    return super.write<{ data: CandidateProfileTopFocusAreas }>({
      endpoint: `/candidates/${id}/profileTopFocusAreas`,
      body,
      method: 'POST',
    });
  }

  async refreshProfileTopFocusAreas(id: Candidate['id']) {
    return super.invalidate(`/candidates/${id}/profileTopFocusAreas`);
  }
}

export const CandidateProfileTopFocusAreasApi =
  new CandidateProfileTopFocusAreasApiClass();
